import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextFielDecimalNumbers,
  Divider,
  Typography,
  Autocomplete,
  TextField,
} from "../../../../components";
import {
  FamiliaProdutosService,
  GrupoProdutosService,
  notification,
  PessoaService,
  SubfamiliaProdutosService,
  SubgrupoProdutosService,
  TabelaVendaService,
} from "../../../../services";
import { Grid } from "../../../../components";
import { value } from "../../../../helpers";
import { responseErros } from "../../../../utils";
import shortid from "shortid";

const FiltroProdutosDialog = ({
  open,
  setOpen,
  filtros,
  setFiltros,
  handleOperacaoChange,
  handleAjusteChange,
  resetForm,
  tabelaProdutos,
  setTabelaProdutos,
  tabelaVendaEntity,
  tabelaVenda,
  setTabelaVenda,
}) => {
  const gruposProdutosService = new GrupoProdutosService();
  const subgrupoProdutosService = new SubgrupoProdutosService();
  const familiaProdutosService = new FamiliaProdutosService();
  const subfamiliaProdutosService = new SubfamiliaProdutosService();
  const pessoaService = new PessoaService();
  const tabelaVendaService = new TabelaVendaService();

  const [gruposOptions, setGruposOptions] = useState([]);
  const [subgruposOptions, setSubgruposOptions] = useState([]);
  const [familiasOptions, setFamiliasOptions] = useState([]);
  const [subfamiliasOptions, setSubfamiliasOptions] = useState([]);
  const [fornecedoresOptions, setFornecedoresOptions] = useState([]);

  useEffect(() => {
    if (open) {
      buscarFornecedores();
      buscarGruposProdutos();
      buscarSubgruposProdutos();
      buscarFamiliasProdutos();
      buscarSubfamiliasProdutos();
    }
  }, [open]);

  const buscarFornecedores = () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 2,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setFornecedoresOptions(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarGruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    gruposProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGruposOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarSubgruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subgrupoProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setSubgruposOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarFamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    familiaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setFamiliasOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarSubfamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subfamiliaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setSubfamiliasOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarProdutosTabela = () => {
    if (validarAddProduto()) return;
    const body = {
      filtros: {
        nonPaginated: true,
        ativado: true,
        ...filtros,
      },
      ...tabelaVenda,
    };
    tabelaVendaService.carregarProdutosLote(body).then((res) => {
      if (!res.isAxiosError) {
        resetForm();
        handleAdicionarProdutos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

    const validarAddProduto = () => {
    if (!tabelaVenda.fator) {
      notification.erroValidacao("Fator");
      return true;
    }
    if (!tabelaVenda.quantidadeMinima) {
      notification.erroValidacao("Quantidade Minima");
      return true;
    }
    if (!Object.keys(filtros).length) {
      notification.alertaGenericos("Adicione pelo menos um filtro");
      return true;
    }
  };

  const handleAdicionarProdutos = async (produtos) => {
    const produtosInvalidos = produtos.filter((produto) =>
      validarAddProduto(produto)
    );
    if (produtosInvalidos.length > 0) {
      console.warn("Produtos inválidos encontrados:", produtosInvalidos);
      return;
    }

    const produtosParaEditar = produtos.filter(
      (produto) => produto?.itemEditado
    );
    const produtosNovos = produtos.filter((produto) => !produto?.itemEditado);

    const mapaIndicesEdicao = new Map();
    if (produtosParaEditar.length > 0) {
      produtosParaEditar.forEach((produto) => {
        const index = tabelaProdutos.findIndex((obj) => obj.id == produto.id);
        if (index !== -1) {
          mapaIndicesEdicao.set(index, produto);
        }
      });
    }

    const { quantidadeMinima, precoPraticado, fator, operacao } = tabelaVenda;

    let tabelaProdutosTemp = [...tabelaProdutos];

    if (mapaIndicesEdicao.size > 0) {
      tabelaProdutosTemp = tabelaProdutosTemp.map((obj, index) => {
        const produtoEdicao = mapaIndicesEdicao.get(index);
        if (produtoEdicao) {
          return {
            ...obj,
            ...produtoEdicao,
            estProdutoId: produtoEdicao?.id,
            quantidadeMinima,
            precoPraticado,
            fator,
            operacao,
          };
        }
        return obj;
      });
    }

    if (produtosNovos.length > 0) {
      const novosProdutos = produtosNovos.map((produto) => ({
        ...tabelaVenda,
        ...produto,
        precoAtual: produto?.precoVenda,
        estProdutoId: produto?.id,
        id: shortid.generate(),
      }));

      tabelaProdutosTemp.push(...novosProdutos);
    }

    if (produtosParaEditar.length > 0 || produtosNovos.length > 0) {
      tabelaVendaEntity.setChangeItens(tabelaProdutosTemp);
      setTabelaVenda({ ...tabelaVendaEntity });
      setTabelaProdutos(tabelaProdutosTemp);
    }

    document.getElementById("produtoId")?.focus();
    resetForm();
  };

  const handleChangeAutocomplete = (name, value) => {
    setFiltros((prevState) => ({
      ...prevState,
      [name]: value ? value.id : null,
    }));
  };

  const handleInputFiltroChange = (e) => {
    setFiltros((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  function onClose() {
    resetForm();
    setFiltros({});
    setOpen(false);
  }

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={onClose}>
      <DialogContent>
        <CardHeader title="Filtro de Produtos" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
              }}
            >
              <RadioGroup
                row
                name="operacao"
                value={tabelaVenda?.operacao}
                onChange={handleOperacaoChange}
                sx={{
                  p: 0,
                  m: 0,
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <FormControlLabel
                  value="somar"
                  control={<Radio size="small" />}
                  label="Somar"
                  sx={{ m: 0, mr: 1 }}
                />
                <FormControlLabel
                  value="subtrair"
                  control={<Radio size="small" />}
                  label="Subtrair"
                  sx={{ m: 0 }}
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={4}>
              <TextFielDecimalNumbers
                id="fator"
                name="fator"
                label="Fator"
                variant="outlined"
                required
                value={tabelaVenda?.fator}
                onBlur={handleAjusteChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="quantidadeMinima"
                name="quantidadeMinima"
                label="Quantidade Mínima"
                variant="outlined"
                margin="normal"
                type="number"
                required
                value={tabelaVenda?.quantidadeMinima}
                onChange={handleAjusteChange}
                fullWidth
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 2, border: "1px solid grey", width: "100%" }} />
          <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
            Filtros
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="grupoProdutoId"
                name="grupoProdutoId"
                options={gruposOptions}
                autoHighlight
                getOptionLabel={(option) =>
                  option.codigo ? `${option.codigo} - ${option.descricao}` : ""
                }
                noOptionsText={"Nenhum grupo de produto encontrado"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grupo de Produto"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  handleChangeAutocomplete("grupoProdutoId", value)
                }
                value={value.autoComplete(
                  gruposOptions,
                  filtros?.grupoProdutoId
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="subgrupoProdutoId"
                name="subgrupoProdutoId"
                options={subgruposOptions}
                autoHighlight
                getOptionLabel={(option) =>
                  option.codigo ? `${option.codigo} - ${option.descricao}` : ""
                }
                noOptionsText={"Nenhum subgrupo encontrado"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Subgrupo de Produto"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  handleChangeAutocomplete("subgrupoProdutoId", value)
                }
                value={value.autoComplete(
                  subgruposOptions,
                  filtros?.subgrupoProdutoId
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="familiaProdutoId"
                name="familiaProdutoId"
                options={familiasOptions}
                autoHighlight
                getOptionLabel={(option) =>
                  option.codigo ? `${option.codigo} - ${option.descricao}` : ""
                }
                noOptionsText={"Nenhuma família encontrada"}
                renderInput={(params) => (
                  <TextField {...params} label="Família" variant="outlined" />
                )}
                onChange={(e, value) =>
                  handleChangeAutocomplete("familiaProdutoId", value)
                }
                value={value.autoComplete(
                  familiasOptions,
                  filtros?.familiaProdutoId
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="subfamiliaProdutoId"
                name="subfamiliaProdutoId"
                options={subfamiliasOptions}
                autoHighlight
                getOptionLabel={(option) =>
                  option.codigo ? `${option.codigo} - ${option.descricao}` : ""
                }
                noOptionsText={"Nenhuma subfamília encontrada"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Subfamília"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  handleChangeAutocomplete("subfamiliaProdutoId", value)
                }
                value={value.autoComplete(
                  subfamiliasOptions,
                  filtros?.subfamiliaProdutoId
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                id="fornecedorId"
                name="fornecedorId"
                options={fornecedoresOptions}
                noOptionsText="Sem opções"
                autoHighlight
                getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Fornecedor"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  handleChangeAutocomplete("fornecedorId", value)
                }
                value={value.autoComplete(
                  fornecedoresOptions,
                  filtros?.fornecedorId
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Faixa de Código (Inicial)"
                name="codigoInicial"
                value={filtros.codigoInicial}
                onChange={handleInputFiltroChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Faixa de Código (Final)"
                name="codigoFinal"
                value={filtros.codigoFinal}
                onChange={handleInputFiltroChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button variant="contained" color="padrao" onClick={onClose}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={buscarProdutosTabela}
            startIcon={
              <i
                className="ph-bold ph-magnifying-glass"
                style={{ color: "white" }}
              ></i>
            }
          >
            Buscar Produtos
          </Button>
        </CardActions>
      </DialogContent>
    </Dialog>
  );
};

export default FiltroProdutosDialog;
